import { Chat } from "./Chat";
import { Queue } from "./Queue";
import { User } from "./User";

export enum ServiceStatus {
  AUTOMATED = "AUTOMATED",
  WAITING = "WAITING",
  PROGRESS = "PROGRESS",
  FINALIZED = "FINALIZED",
  CONVERSATIONS = "CONVERSATIONS",
};

export interface Service {
  id: string;
  isDraft?: boolean;
  unReadCount: number;
  chat: Chat;
  userId?: string | null;
  queueId?: string | null;
  user?: User;
  queue: Queue;
  status: ServiceStatus;
  acceptedTerms: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
};
